export default __webpack_public_path__ + "static/bg-5-c3dd0c5253458a5c75ca0100708cc765.png";